import { unAuthUser } from './index';
import * as types from './action-types';

export const checkErrorMessage = message => (dispatch, getState) => {
    if (message === 'Invalid token') {
        //Redirects them to adportal
        dispatch(unAuthUser);
    } else {
        console.log(message);
    }
};

export const setSessionModal = () => {
    return {
        type: types.SESSION_MODAL
    };
};



// WEBPACK FOOTER //
// ./src/actions/general.js